
import React from 'react';
import { Bet, BetOutcome } from '../types.ts';
import { DollarSign, Percent, Target, Swords, Activity } from 'lucide-react';

interface StatsCardsProps {
  bets: Bet[];
}

const StatsCards: React.FC<StatsCardsProps> = ({ bets }) => {
  if (!bets || bets.length === 0) return null;

  const totalProfit = bets.reduce((acc, b) => acc + (b.profit || 0), 0);
  const totalStake = bets.reduce((acc, b) => acc + b.stake, 0);
  const roi = totalStake > 0 ? (totalProfit / totalStake) * 100 : 0;

  const greensTotal = bets.filter(b => b.outcome === BetOutcome.GREEN).length;
  const winRate = bets.length > 0 ? (greensTotal / bets.length) * 100 : 0;

  const filteredGreens = bets.filter(b => b.outcome === BetOutcome.GREEN).length;
  const filteredReds = bets.filter(b => b.outcome === BetOutcome.RED).length;

  // Cálculo de Média de Gols
  const betsWithGoals = bets.filter(b => b.player1_goals !== undefined && b.player2_goals !== undefined);
  const totalGoals = betsWithGoals.reduce((acc, b) => acc + (b.player1_goals || 0) + (b.player2_goals || 0), 0);
  const avgGoals = betsWithGoals.length > 0 ? totalGoals / betsWithGoals.length : 0;

  const stats = [
    {
      label: 'Lucro do Período',
      value: `$ ${totalProfit.toFixed(2)}`,
      icon: <DollarSign className="text-white" />,
      color: totalProfit >= 0 ? 'text-[#00ff66]' : 'text-[#f6465d]'
    },
    {
      label: 'Performance (ROI)',
      value: `${roi.toFixed(1)}%`,
      icon: <Percent className="text-white" />,
      color: roi >= 0 ? 'text-[#00ff66]' : 'text-[#f6465d]'
    },
    {
      label: 'Média de Gols/Jogo',
      value: `${avgGoals.toFixed(2)}`,
      icon: <Activity className="text-white" />,
      color: 'text-[#fbbf24]'
    },
    {
      label: 'Placar (G x R)',
      value: (
        <span className="flex items-center gap-2">
          <span className="text-[#00ff66]">{filteredGreens}</span>
          <span className="text-[#eaecef] opacity-30 font-light text-xl">x</span>
          <span className="text-[#f6465d]">{filteredReds}</span>
        </span>
      ),
      icon: <Swords className="text-white" />,
      isCustom: true
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, idx) => (
        <div key={idx} className="bg-[#1e2329] p-6 rounded-2xl border border-[#474d57] hover:border-[#fbbf24]/40 transition-all cursor-default shadow-sm group">
          <div className="flex items-center justify-between mb-4">
            <span className="text-white text-[10px] font-black uppercase tracking-[0.2em]">{stat.label}</span>
            <div className="p-2.5 bg-[#0b0e11] rounded-xl border border-[#474d57]/30 group-hover:scale-110 transition-transform">
              {stat.icon}
            </div>
          </div>
          <div className={`text-3xl font-black font-mono tracking-tighter ${stat.isCustom ? '' : stat.color}`}>
            {stat.value}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
